import React from 'react';

interface AuthButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'iam' | 'email' | 'spid' | 'generate' | 'link';
  loading?: boolean;
  fullWidth?: boolean;
}

const variantClasses: Record<string, string> = {
  primary:
    'tw-bg-blue-500 tw-text-white hover:tw-bg-blue-600 hover:-tw-translate-y-0.5 hover:tw-shadow-lg',
  secondary:
    'tw-bg-gray-500 tw-text-white hover:tw-bg-gray-600 hover:-tw-translate-y-0.5',
  iam:
    'tw-bg-blue-500 tw-text-white hover:tw-bg-blue-600 hover:-tw-translate-y-0.5 hover:tw-shadow-lg',
  email:
    'tw-bg-green-600 tw-text-white hover:tw-bg-green-700 hover:-tw-translate-y-0.5 hover:tw-shadow-lg',
  spid:
    'tw-bg-blue-700 tw-text-white hover:tw-bg-blue-800 hover:-tw-translate-y-0.5',
  generate:
    'tw-bg-white tw-text-gray-600 tw-border tw-border-gray-300 tw-shadow-none tw-text-sm tw-min-h-[44px] hover:tw-bg-gray-50 hover:tw-border-gray-400 hover:tw-text-gray-800',
  link:
    'tw-bg-transparent tw-text-gray-500 tw-shadow-none tw-text-sm tw-min-h-0 tw-py-2 tw-px-4 tw-underline hover:tw-text-gray-700',
};

export default function AuthButton({
  variant = 'primary',
  loading,
  fullWidth = true,
  children,
  disabled,
  className,
  ...props
}: AuthButtonProps) {
  return (
    <button
      type="button"
      className={`tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-py-3.5 tw-px-5 tw-rounded-lg tw-font-semibold tw-text-[15px] tw-tracking-wide tw-border-none tw-cursor-pointer tw-transition-all tw-duration-200 tw-shadow-sm tw-min-h-[48px] ${fullWidth ? 'tw-w-full' : ''} ${variantClasses[variant] || variantClasses.primary} ${disabled || loading ? 'tw-opacity-50 tw-cursor-not-allowed tw-transform-none tw-shadow-none' : ''} ${className || ''}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="tw-w-5 tw-h-5 tw-border-2 tw-border-white/30 tw-border-t-white tw-rounded-full tw-animate-spin" />
      ) : (
        children
      )}
    </button>
  );
}
